var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customcard"},[_c('vs-tabs',{staticClass:"mb-8"},[_vm._t("default")],2),_c('QuickInsights',{class:{ hidden: !_vm.hasQuickInsights }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }